import { useContext } from 'react';
import { TreeChoicesContext, } from './TreeChoicesContext';
export var useTreeChoicesContext = function () {
    return (useContext(TreeChoicesContext) || {});
};
